module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-bottom-metals.04bd4126.png";